import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react"
import IndexPage from "./pages/IndexPage";
import SupportPage from "./pages/SupportPage";
import MeetPage from "./pages/MeetPage";

function ExternalRedirect({ url }: { url: string }) {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return null;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/about" element={<IndexPage expand="about" />} />
        <Route path="/jobs" element={<IndexPage expand="jobs" />} />
        <Route path="/who" element={<IndexPage expand="who" />} />
        <Route path="/love" element={<IndexPage expand="valentine" />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/meet/:person" element={<MeetPage />} />
        <Route path="/roles/pmcx" element={<IndexPage expand="pmcx" />} />
        <Route path="/roles/pmdx" element={<IndexPage expand="pmdx" />} />
        <Route path="/roles/engp" element={<ExternalRedirect url="http://forms.gle/odjeo7vAxixFVgB88" />} />
        <Route path="/roles/engx" element={<ExternalRedirect url="http://forms.gle/JYZbSGtUHWGjgXSB9" />} />
      </Routes>
    </Router>
  );
}

export default App;
